<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Course Information" />

        <container-list-item padded no-border>
            <b-field label="Title" label-position="inside">
                <b-input v-model="course.title"></b-input>
            </b-field>

            <b-field label="Code" label-position="inside">
                <b-input v-model="course.code" v-mask="'NNNNNNNNNNNNNNN'" maxlength="20"></b-input>
            </b-field>

        </container-list-item>

        <subheader-list-item icon="fa-align-left" title="Course details" />

        <container-list-item padded no-border>
            <b-field label="Description" label-position="inside">
                <b-input type="textarea" v-model="course.description"></b-input>
            </b-field>
            <b-field label="Welcome Message">
                <quill-editor v-model="course.welcome" ref="descriptionEditor" :options="editorOptions" class="has-background-white content" />
            </b-field>
        </container-list-item>

        <subheader-list-item icon="fa-align-left" title="Advanced Options" />
        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Logo URL" label-position="inside">
                        <b-input v-model="course.logo"></b-input>
                    </b-field>
                    <b-field label="Logo (White) URL" label-position="inside">
                        <b-input v-model="course.logo_white"></b-input>
                    </b-field>
                    <b-field class="mt-5">
                        <b-switch v-model="course.active" :true-value="1" :false-value="0">Course Active</b-switch>
                    </b-field>
                    <b-field>
                        <b-switch v-model="course.is_hidden" :true-value="1" :false-value="0">Hidden from Course Catalog (Code Only)</b-switch>
                    </b-field>
                    <hr />
<!--                    <b-field>-->
<!--                        <b-switch v-model="course.show_welcome" :true-value="1" :false-value="0">Show Course Welcome Screen</b-switch>-->
<!--                    </b-field>-->
                    <b-field>
                        <b-switch v-model="course.show_titles" :true-value="1" :false-value="0">Show Lesson Header Titles</b-switch>
                    </b-field>
                    <b-field>
                        <b-switch v-model="course.content_framed" :true-value="1" :false-value="0">Lesson Content is Framed</b-switch>
                    </b-field>
                    <b-field>
                        <b-switch v-model="course.show_timer" :true-value="1" :false-value="0">Show Lesson Timer</b-switch>
                    </b-field>
                    <hr />
                    <b-field>
                        <b-switch v-model="course.test_mode" :true-value="1" :false-value="0">Test Mode</b-switch>
                    </b-field>
                    <b-field>
                        <b-switch v-model="course.disable_timer" :true-value="1" :false-value="0">Ignore Required Time</b-switch>
                    </b-field>
                </div>
            </div>

        </container-list-item>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";
    import {client as http} from "@/http_client";
    import draggable from "vuedraggable";

    export default {
        name: 'CourseForm',
        props: {
            course: {
                type: Object,
                required: true
            },
            card: {
                type: Object,
                required: true
            },
            child: {
                type: Object,
                required: false
            }
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList, draggable},
        data: function () {
            return {
                type: null,
                title: null,
                preComponentSelect: null,
                postComponentSelect: null,
                sectionSelect: null,
                components: [],
                sections: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {
            loadSections(force) {
                this.$emit('loading', true);

                // http.get('components/', {force}).then(response => {
                //     this.components = response.data;
                //     this.$emit('loading', false);
                // }, err => {
                //     console.log(err);
                // });

                http.get('sections/', {force}).then(response => {
                    this.sections = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            addOutline() {
                http.post('courses/outline/', {
                    type: 'SECTION',
                    course_id: this.course.id,
                    type_id: (this.sectionSelect) ? this.sectionSelect.id : null,
                    sort: this.course.course_outline.length + 1,
                    title: this.title
                }, {force: true}).then(response => {
                    console.log(response.data);
                    this.course.course_outline.push(response.data);
                    this.type = null;
                    this.title = '';
                    this.sectionSelect = null;
                }, err => {
                    console.log(err);
                });
            },
            addRequiredComponent(type, component) {
                http.post('courses/component/', {
                    type: type,
                    entity_id: this.course.id,
                    component_id: component.id
                }, {force: true}).then(response => {
                    if (type === 'pre') {
                        this.preComponentSelect = null;
                    } else {
                        this.postComponentSelect = null;
                    }
                }, err => {
                    console.log(err);
                });
            },
            completeDrag: function () {
                http.post('courses/outline/order', this.course.course_outline.map(i => i.id)).then(response => {

                });
            },
        },
        mounted: function () {
            this.loadSections();
        }
    };
</script>

<style lang="scss" scoped>
    .drag-handle {
        cursor: ns-resize;
    }
</style>
